import React from 'react';
import Image from '@jy95/material-ui-image';
import PropTypes from 'prop-types';

function BaseImage({ ratio = '1:1', src, alt, rounded = false, round, size, ...restProps }: any) {
  const [width, height] = ratio.split(':');
  const calculatedRatio = parseInt(width, 10) / parseInt(height, 10);
  const isRatioWithFixedHeight = ['fullHeight'].includes(ratio);

  return (
    <div style={{ width: '100%' }}>
      <Image
        disableTransition
        src={src}
        alt={alt}
        // disable the ratio if it's fullHeight
        aspectRatio={isRatioWithFixedHeight ? 1 : calculatedRatio}
        style={isRatioWithFixedHeight ? { paddingTop: 'inherit' } : {}}
        imageStyle={{
          ...(isRatioWithFixedHeight ? { position: 'relative' } : {}),
          ...(rounded ? { borderRadius: 8 } : {}), // `borderRadius: 8` same as `MuiPaper`
          ...(round ? { borderRadius: '50%', width: size[0], height: size[1] } : {}),
          ...(size && !round ? { maxWidth: size[0], maxHeight: size[1] } : {}),
          objectFit: 'cover',
          objectPosition: 'center center',
        }}
        color="transparent"
        {...restProps}
      />
    </div>
  );
}

BaseImage.propTypes = {
  ratio: PropTypes.oneOf(['fullHeight', '1:1', '3:2']),
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  rounded: PropTypes.bool,
  title: PropTypes.string,
  size: PropTypes.arrayOf(PropTypes.number),
  onClick: PropTypes.func,
};

export default BaseImage;
